<template>
  <div class="content" v-if="route.name == 'Beranda'">
    <Beranda/>
  </div>
  <div class="content" v-if="route.name == 'Beranda2'">
    <Beranda2/>
  </div>
  <div class="content" v-if="route.name == 'DataProfil'">
    <DataProfil/>
  </div>
  <div class="content" v-if="route.name == 'Login'">
    <Login/>
  </div>
  <div class="content" v-if="route.name == 'KontakKami'">
    <KontakKami/>
  </div>
  <div class="content" v-if="route.name == 'Riwayat'">
    <Riwayat/>
  </div>
  <div class="content" v-if="route.name == 'Usulan'">
    <Usulan/>
  </div>
  <div class="content" v-if="route.name == 'BankDokumen'">
    <BankDokumen/>
  </div>
  <div class="content" v-if="route.name == 'SDALH'">
    <SDALH/>
  </div>
  <div class="content" v-if="route.name == 'ProfilKemiskinan'">
    <ProfilKemiskinan/>
  </div>
  <div class="content" v-if="route.name == 'Dashboard'">
    <Dashboard/>
  </div>
  <div class="content" v-if="route.name == 'Slider'">
    <Slider/>
  </div>
  <div class="content" v-if="route.name == 'ProsesSlider'">
    <ProsesSlider/>
  </div>
  <div class="content" v-if="route.name == 'InfoBeranda'">
    <InfoBeranda/>
  </div>
  <div class="content" v-if="route.name == 'ProsesInfoBeranda'">
    <ProsesInfoBeranda/>
  </div>
  <div class="content" v-if="route.name == 'Profil'">
    <Profil/>
  </div>
  <div class="content" v-if="route.name == 'ProsesProfil'">
    <ProsesProfil/>
  </div>
  <div class="content" v-if="route.name == 'User'">
    <User/>
  </div>
  <div class="content" v-if="route.name == 'ProsesUser'">
    <ProsesUser/>
  </div>
  <div class="content" v-if="route.name == 'GIS'">
    <GIS/>
  </div>
  <div class="content" v-if="route.name == 'LayerPeta'">
    <LayerPeta/>
  </div>
  <div class="content" v-if="route.name == 'Dokumen'">
    <Dokumen/>
  </div>
</template>

<script>
import Beranda from './components/views/Publik/Beranda.vue';
import Beranda2 from './components/views/Publik/Beranda.vue';
import DataProfil from './components/views/Publik/Profil.vue';
import Login from './components/views/Publik/Login.vue';
import KontakKami from './components/views/Publik/KontakKami.vue';
import GIS from './components/views/Publik/GIS.vue';
import Riwayat from './components/views/Publik/Riwayat.vue';
import Usulan from './components/views/Publik/Usulan.vue';
import BankDokumen from './components/views/Publik/BankDokumen.vue';
import SDALH from './components/views/Publik/SDALH.vue';
import ProfilKemiskinan from './components/views/Publik/ProfilKemiskinan.vue';
import Dashboard from './components/views/Dashboard/Dashboard.vue';
import Slider from './components/views/Backoffice/Slider/Slider.vue';
import ProsesSlider from './components/views/Backoffice/Slider/ProsesSlider.vue';
import InfoBeranda from './components/views/Backoffice/InfoBeranda/InfoBeranda.vue';
import ProsesInfoBeranda from './components/views/Backoffice/InfoBeranda/ProsesInfoBeranda.vue';
import Profil from './components/views/Backoffice/Profil/Profil.vue';
import ProsesProfil from './components/views/Backoffice/Profil/ProsesProfil.vue';
import User from './components/views/Backoffice/User/User.vue';
import ProsesUser from './components/views/Backoffice/User/ProsesUser.vue';
import LayerPeta from './components/views/Backoffice/LayerPeta/LayerPeta.vue';
import Dokumen from './components/views/Backoffice/Dokumen/Dokumen.vue';

import { useRoute } from 'vue-router';
import { watch } from 'vue';

export default {
  name: 'App',
  components: {
    Beranda,Beranda2,Login,KontakKami,DataProfil,Riwayat,Usulan,Dashboard
    ,Slider,ProsesSlider,InfoBeranda,ProsesInfoBeranda,Profil,ProsesProfil
    ,User,ProsesUser,GIS,LayerPeta,Dokumen,BankDokumen,SDALH,ProfilKemiskinan
  },
  mounted() {
    document.title = "SimfastJateng";
  },
  setup() {
    const route = useRoute()
    watch(() => route.name, () => {
    });

    return { route };
  }
}
</script>

<style></style>
